import React from "react";
import "./PortfolioPage.css";


interface HomePageProps {
	lang: string;
}

/**
 * Adds two numbers together.
 * @param {HomePageProps} props contains language
 * @return {JSX.Element} The sum of the two numbers.
 */
export default function PortfolioPage(props: HomePageProps): JSX.Element {
	return (
		<div className="page" id="portfolioPage">
			In development
		</div>
	);
}
